import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ApiServices from "../config/ApiServices";
import { setData } from "../redux/actions/DataAction";

export default function TrainerSideBar(){
    const batches=useSelector((state)=>state.data.data)
    const dispatch=useDispatch()
    const userId=sessionStorage.getItem("userId")
    useEffect(()=>{
        ApiServices.apiRequest("getBatch",{trainerId:userId, status:true})
        .then((result)=>{
            if(result.data.success){
                dispatch(setData(result.data.data))
                
            }
        })
        .catch((err)=>{
            //console.log(err);
        })
    },[])
    return(
        <>
         <div className="sidebar" data-background-color="dark">
            <div className="sidebar-logo">
            {/* Logo Header */}
            <div className="logo-header" data-background-color="dark">
                <Link 
                to={'/trainer'} className="logo text-light fs-4">
                 <img
                    src="/assets/img/logo2.png"
                    alt="navbar brand"
                    className="navbar-brand"
                    height={40}
                /> 
                
                </Link>
                <div className="nav-toggle">
                <button className="btn btn-toggle toggle-sidebar">
                    <i className="gg-menu-right" />
                </button>
                <button className="btn btn-toggle sidenav-toggler">
                    <i className="gg-menu-left" />
                </button>
                </div>
                <button className="topbar-toggler more">
                <i className="gg-more-vertical-alt" />
                </button>
            </div>
            {/* End Logo Header */}
            </div>
            <div className="sidebar-wrapper scrollbar scrollbar-inner">
            <div className="sidebar-content">
                <ul className="nav nav-secondary">
                <li className="nav-item ">
                    <Link
                    to={"/trainer"}
                    >
                    <i className="fas fa-home" />
                    <p>Dashboard</p>
                    </Link>
                </li>
                <li className="nav-section">
                    <span className="sidebar-mini-icon">
                    <i className="fa fa-ellipsis-h" />
                    </span>
                    <h4 className="text-section">Manage</h4>
                </li>
                <li className="nav-item">
                    <Link to="/trainer/students">
                    <i className="fas fa-user-graduate" />
                    <p>Students</p>
                    </Link>
                </li>
                {
                    batches?.length>0?
                    batches?.map((el,index)=>(
                        <li className="nav-item">
                        <Link to={"/trainer/viewBatches/"+el._id}>
                        {/* <i className="fas fa-layer-group" /> */}
                        <p>{el?.name}<br/><span style={{fontSize:"0.9rem"}}>{el?.time}</span></p>
                        <span className="caret" />
                        </Link>
                       
                    </li>
                    ))
                    :
                    <li className="nav-item">
                        <Link to="/trainer/batches">
                        <i className="fas fa-layer-group" />
                        <p>Batches</p>
                        </Link>
                    </li>
                }
                {/* {
                    batches?.length>0?
                    batches?.map((el,index)=>(
                        <li className="nav-item">
                        <a data-bs-toggle="collapse" href={`#${index}`}>
                        <i className="fas fa-layer-group" />
                        <p>{el?.name}<br/><span style={{fontSize:"0.9rem"}}>{el?.time}</span></p>
                        <span className="caret" />
                        </a>
                        <div className="collapse" id={index}>
                        <ul className="nav nav-collapse">
                            <li>
                            <Link to={`/trainer/schedules/${el?._id}`}>
                                <span className="sub-item">Schedule</span>
                            </Link>
                            </li>
                            <li>
                            <Link to={`/trainer/material/${el?._id}`}>
                                <span className="sub-item">Material</span>
                            </Link>
                            </li>
                            <li>
                            <Link to={`/trainer/tasks/${el?._id}`}>
                                <span className="sub-item">Tasks</span>
                            </Link>
                            </li>
                            <li>
                            <Link to={`/trainer/peoples/${el?._id}`}>
                                <span className="sub-item">Students</span>
                            </Link>
                            </li>
                            <li>
                            <Link to={`/trainer/trainers/${el?._id}`}>
                                <span className="sub-item">Trainers</span>
                            </Link>
                            </li>
                        </ul>
                        </div>
                    </li>
                    ))
                    :
                    <li className="nav-item">
                        <Link to="/trainer/batches">
                        <i className="fas fa-layer-group" />
                        <p>Batches</p>
                        </Link>
                    </li>
                } */}
                </ul>
            </div>
            </div>
        </div>
        </>
    )
}